<!--High-->
<seo-duplicate-title *ngIf="seoName === 'seo_duplicate_title'"></seo-duplicate-title>
<seo-missing-h1 *ngIf="seoName === 'seo_missing_h1'"></seo-missing-h1>
<seo-missing-title *ngIf="seoName === 'seo_missing_title'"></seo-missing-title>

<!--Medium-->
<seo-duplicate-h1 *ngIf="seoName === 'seo_duplicate_h1'"></seo-duplicate-h1>
<seo-missing-alt *ngIf="seoName === 'seo_missing_alt'"></seo-missing-alt>
<seo-multiple-h1 *ngIf="seoName === 'seo_multiple_h1'"></seo-multiple-h1>
<seo-missing-subheadlines *ngIf="seoName === 'seo_missing_subheadlines'"></seo-missing-subheadlines>

<!--Low-->
<seo-missing-meta-description *ngIf="seoName === 'seo_missing_meta_description'"></seo-missing-meta-description>
<seo-too-long-meta-description *ngIf="seoName === 'seo_too_long_meta_description'"></seo-too-long-meta-description>
<seo-too-long-url *ngIf="seoName === 'seo_too_long_url'"></seo-too-long-url>
<seo-too-many-page-links *ngIf="seoName === 'seo_too_many_page_links'"></seo-too-many-page-links>
<seo-too-short-meta-description *ngIf="seoName === 'seo_too_short_meta_description'"></seo-too-short-meta-description>

<!-- Technical -->
<seo-no-follow *ngIf="seoName === 'seo_no_follow'"></seo-no-follow>
<seo-no-index *ngIf="seoName === 'seo_no_index'"></seo-no-index>
